import React from 'react'

const AppSearchBox = (props) => {

    const {searchTerm,setSearchTerm,setSearchTermCompleted} = props;

    const handleKeyDownOnSearch = (event) => {
        if (event.key === 'Enter') {
           
          setSearchTermCompleted(searchTerm);
    
        }
      };

    return (
        <>
            {/* <div className="int-search-btn mb-2">
                <div className="input-group">
                    <input type="text" placeholder="Search..." value={searchTerm} onChange={(event) => setSearchTerm(event.target.value)} onKeyDown={handleKeyDownOnSearch} />
                    <div className="input-group-append">
                        <button type="button" onClick={()=>setSearchTermCompleted(searchTerm)}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.239 30.239" width={18} height={18}><g><g>
                                <path d="M20.194,3.46c-4.613-4.613-12.121-4.613-16.734,0c-4.612,4.614-4.612,12.121,0,16.735   c4.108,4.107,10.506,4.547,15.116,1.34c0.097,0.459,0.319,0.897,0.676,1.254l6.718,6.718c0.979,0.977,2.561,0.977,3.535,0   c0.978-0.978,0.978-2.56,0-3.535l-6.718-6.72c-0.355-0.354-0.794-0.577-1.253-0.674C24.743,13.967,24.303,7.57,20.194,3.46z    M18.073,18.074c-3.444,3.444-9.049,3.444-12.492,0c-3.442-3.444-3.442-9.048,0-12.492c3.443-3.443,9.048-3.443,12.492,0   C21.517,9.026,21.517,14.63,18.073,18.074z" data-original="#000000" className="active-path" data-old_color="#000000" fill="#ffffff" /></g></g>
                            </svg>
                        </button>
                    </div>
                </div>
            </div> */}
            
            {/* <div class="ad-user-btn">
                        <input className="form-control" type="text" placeholder="Search Here..." id="text-input" value={searchTerm} onChange={(event) => setSearchTerm(event.target.value)} onKeyDown={handleKeyDownOnSearch} />

                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56.966 56.966">
                            <path d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23
												s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92
												c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17
												s-17-7.626-17-17S14.61,6,23.984,6z" />
                        </svg>

                    </div> */}

{/* <div className="mb-2 m-md-3  search-bar app-form app-icon-form position-relative w-100 w-md-auto"> */}
<div className="search-bar app-form app-icon-form position-relative w-100 w-md-auto mt-md-0 float-end">
  <input className="form-control" value={searchTerm} onChange={(event) => setSearchTerm(event.target.value)} onKeyDown={handleKeyDownOnSearch} placeholder="type to search" type="search" />
  {/* <i className="ti ti-search text-secondary" /> */}
  <i class="fa-solid fa-search fa-fw"></i>
</div>
        </>
    )
}

export default AppSearchBox
